<template>
  <div class="businessAnalysis">
    <div class="quickEntry">
      <div style="width: 60%">
        <div class="top_box">
          <div>
            <span class="span1">快捷入口</span>
            <span class="span2" @click="quickEntry">设置</span>
          </div>
          <!-- <div class="icon_box">
            <span>&lt;</span>
            <span>></span>
          </div> -->
        </div>
        <div class="tab_list">
          <div v-for="item in resourcesList" :key="item.id" @click="goResources(item.resourceUrl)">{{item.resourceName}}</div>
        </div>
      </div>
      <div class="right_box" style="width: 39%">
        <div @click="goResources('/order/orderList', 1)">
          <p class="num">{{todoForm.toRefundOrderCount}}</p>
          <p class="text">待退款订单</p>
        </div>
        <div @click="goResources('/merchant/messageManage', 1)">
          <p class="num">{{todoForm.toViewMsgCount}}</p>
          <p class="text">待查看消息</p>
        </div>
      </div>
    </div>
    <div class="contet_box">
      <div class="oilStation_box" v-if="oilStationOptions.length > 1">
        <el-select v-model="oilStation" placeholder="请选择" @change="stationChange">
          <el-option
            v-for="item in oilStationOptions"
            :key="item.gasId"
            :label="item.gasName"
            :value="item.gasId">
          </el-option>
        </el-select>
      </div>
      <!-- 实时数据 -->
      <!-- <RealTime v-if="homePage.includes('jyfxsssj')" ref="realTime" :btnJurisdiction="btnJurisdiction" :time="timeData['/business/analysis/realTimeData']"></RealTime> -->
      <RealTime ref="realTime" :btnJurisdiction="btnJurisdiction" :time="timeData['/business/analysis/realTimeData']"></RealTime>
      <!-- 用户分布 -->
      <Map :oilStation="oilStation" v-if="homePage.includes('jyfxyhdt')"></Map>
      <!-- 团油带来车主 -->
      <UserDistribution ref="userDistribution" v-if="homePage.includes('jyfxtydlcz')" :btnJurisdiction="btnJurisdiction" :time="timeData['/business/analysis/realTimeAction']"></UserDistribution>
      <div class="foot_box">
        <!-- 总销售额 -->
        <TotalSales ref="totalSales" v-if="homePage.includes('jyfxzxse')" :btnJurisdiction="btnJurisdiction"></TotalSales>
        <!-- 交易笔数 -->
        <NumOfBusiness ref="numOfBusiness" v-if="homePage.includes('jyfxjybs')" :btnJurisdiction="btnJurisdiction"></NumOfBusiness>
      </div>
      <div class="foot_box">
        <!-- 短信套餐详情 -->
        <SmsPackageDetails ref="smsPackageDetails" v-if="homePage.includes('jyfxdxtcxq')"></SmsPackageDetails>
      </div>
    </div>
    <!-- 快捷入口配置 -->
    <QuickEntry ref="quickEntry" @submitResources="getUserResources"></QuickEntry>
  </div>
</template>
<script>
import RealTime from './components/realTime.vue'
import Map from './components/map.vue'
import UserDistribution from './components/userDistribution.vue'
import TotalSales from './components/totalSales.vue'
import NumOfBusiness from './components/numOfBusiness.vue'
import SmsPackageDetails from './components/SmsPackageDetails.vue'
import QuickEntry from './components/quickEntry.vue'
import { getUserResources, homePageFunction, getBtnJurisdiction, getTimeout } from '@/api/businessAnalysis'
import { getAllGasInfoList } from '@/api/gasStationManage/gasInfo'
import { getToDoList } from '@/api/customer/index'

export default {
  components: { RealTime, Map, UserDistribution, TotalSales, NumOfBusiness, SmsPackageDetails, QuickEntry },
  data () {
    return {
      oilStation: undefined,
      oilStationOptions: [],
      resourcesList: [],
      todoForm: {},
      btnJurisdiction: {},
      homePage: [],
      timeData : {}
    }
  },
  created () {
    this.$track.pageViewEvent('经营分析', '1655798950')
  },
  mounted () {
    this.getAllGasInfoList()
    this.getUserResources()
    this.getToDoListApi()
    this.getTimeout()
  },
  methods: {
    quickEntry () {
      this.$track.clickEvent('经营分析-设置', '1655798952')
      this.$refs.quickEntry.init()
    },
    goResources (url, type) {
      this.$router.push({ path: url })
      if (type) this.$store.commit('saveCustomer/SET_SAVE_INFO', { isCheck: true })
    },
    // 切换油站
    stationChange () {
      this.resetData()
    },
    // 刷新数据
    resetData () {
      this.homePageFunction()
      this.getBtnJurisdiction()
    },
    // 获取快捷入口
    async getUserResources () {
      try {
        const { code, result } = await getUserResources()
        if (code !== 200) return
        this.resourcesList = result
      } catch (error) {
        console.log(error)
      }
    },
    async getAllGasInfoList () {
      try {
        const { code, result } = await getAllGasInfoList()
        if (code !== 200) return
        console.log(result)
        this.oilStationOptions = result
        this.oilStation = this.oilStationOptions[0].gasId
        // this.$refs.realTime.init(this.oilStation)
        this.stationChange()
      } catch (error) {
        console.log(error)
      }
    },
    // 取分页获取站内信
    async getToDoListApi () {
      try { 
        const { code, result } = await getToDoList()
        if(code !== 200) return
        this.todoForm = result
      } catch (e) {
        console.log(e)
      }
    },
    // 获取首页控制
    async homePageFunction () {
      try { 
        const { code, result } = await homePageFunction({ gasId: this.oilStation })
        if(code !== 200) return
        this.homePage = result
        this.$nextTick(() => {
          if (this.homePage.includes('jyfxsssj')) {
            this.$refs.realTime.init(this.oilStation)
          }
          if (this.homePage.includes('jyfxtydlcz')) {
            this.$refs.userDistribution.init(this.oilStation)
          }
          if (this.homePage.includes('jyfxzxse')) {
            this.$refs.totalSales.init(this.oilStation)
          }
          if (this.homePage.includes('jyfxjybs')) {
            this.$refs.numOfBusiness.init(this.oilStation)
          }
          if (this.homePage.includes('jyfxdxtcxq')) {
            this.$refs.smsPackageDetails.init()
          }
        })
      } catch (e) {
        console.log(e)
      }
    },
    // 获取按钮权限
    async getBtnJurisdiction () {
      try { 
        const { code, result } = await getBtnJurisdiction()
        if(code !== 200) return
        this.btnJurisdiction = result
      } catch (e) {
        console.log(e)
      }
    },
    // 获取定时器时间
    async getTimeout () {
      try { 
        const { code, result } = await getTimeout()
        if(code !== 200) return
        this.timeData = result
      } catch (e) {
        console.log(e)
      }
    },
  }
}
</script>
<style lang="less" scoped>
@import url('./style/index.less');
/deep/.realTime .el-radio-button__orig-radio:checked+.el-radio-button__inner{
  color: #409EFF;
  background-color: #fff;
  border-color: #409EFF;
  box-shadow: -1px 0 0 0 #409eff;
}
</style>